import { DefaultResponseHandler } from "./ResponseHandler";
import { MsgBox } from "~/components/MsgBox";
import { auth } from "~/core/Auth";
import { WebApi } from ".";
export class MyPageResponseHandler extends DefaultResponseHandler {
    router;
    constructor(router) {
        super();
        this.router = router;
    }
    handleError(response, config) {
        let status = response.status;
        let message = this.errors[status] || response.statusText;
        if (status === 401) {
            if (auth.isAuthenticated) {
                auth.logoutLocal();
            }
            if (auth.sessionTimeoutHandled) {
                throw this.error(status, message);
            }
            auth.sessionTimeoutHandled = true;
            WebApi.antiForgery.refresh();
            MsgBox.error("セッションが切れました。<br>再度ログインしてください。");
            this.router.push({ name: "timeout" });
            throw this.error(status, response.data.errorMessage);
        }
        else if (status === 400 && typeof response.data.code !== "undefined") {
            throw this.error(status, response.data.errorMessage, response.data);
        }
        else if (status === 500) {
            throw this.error(status, response.data.title, response.data);
        }
        else if (status === 404) {
            this.router.replace({ name: "404" });
            throw this.error(status, response.data.errorMessage);
        }
        else {
            throw this.error(status, message, response.data);
        }
    }
    data(response, config) {
        if (response.data instanceof Blob) {
            return response.data;
        }
        if (!response.data) {
            return null;
        }
        if (response.status === 401) {
            return null;
        }
        // Result形式じゃない
        if (response.data.success == null) {
            return response.data;
        }
        let result = response.data;
        if (result.success) {
            return result;
        }
        throw this.error(response.status, result.errorMessage, result);
    }
}
